module.exports = __webpack_public_path__ + "img/home_bg1.62c4fea6.png";